import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  params: {
    page: 1,
    limit: 10,
    searchText: '',
    storeNo: null,
    condition: 'CONDITION_ALL', // CONDITION_STORE , CONDITION_USER 구분값(Const)
    regDate: '',
    startDate: '',
    endDate: ''
  },
  pageInfo: {
    limit: 10,
    page: 1
  },
  detail: {
    storeNo: 0,
    userNo: 0,
    userId: '',
    storeCategoryNo: 0,
    storeTypeNo: 0,
    locationNo: 0,
    owner: 0,
    phone: '01012341234',
    nameKr: 0,
    nameVn: 0,
    address: '',
    addressDetail: '',
    tagVn: '',
    tagKr: '',
    blog: '',
    youtube: '',
    hasOffline: true,
    isActive: true,
    isShow: true,
    isWork: true,
    isDeliverable: true,
    isChattable: true,
    isQueryable: true,
    isSupportDelivery: true,
    isSupportPacking: true,
    isSupportVisit: true,
    isViaCash: true,
    isViaCard: true,
    isViaAutomaticWithdrawal: true,
    isViaOnlinePayment: true,
    isPointAvailable: true,
    introduceKr: '',
    introduceVn: '',
    noticeKr: '',
    noticeVn: '',
    regDate: '',
    updateDate: '',
    supportLanguage: '',
    isNegoDeliveryFee: false,
    baseDeliveryFee: 0,
    baseDeliveryFeeLimit: 0,
    increaseDeliveryFeePer: 0,
    additionalDeliveryFee: 0,
    maximumDeliveryFee: 0,
    noDeliveryFeeWhen: 0,
    minimumPriceForDelivery: 0,
    minimumDeliveryDuration: 0,
    maximumDeliveryDuration: 0,
    ifAcceptDelivery: 0,
    exceedMinutes: 0,
    discountWhenPack: 0,
    orderCommissions: 0.0,
    lastCommissionModifiedDate: '',
    latitude: '',
    longitude: '',
    storeNoticeKr: '',
    storeNoticeVn: '',
    storeAccounts: [
      { bank: '', accountNumber: '', depositHolder: '' },
      { bank: '', accountNumber: '', depositHolder: '' }
    ],
    businessDays: [],
    breakTimes: [],
    holidays: [],
    serviceableAreas: [],
    files: [],
    rawFiles: [],

    storeType: {
      storeTypeNo: null,
      typeKr: '',
      typeVn: '',
      regDate: '',
      isActive: true
    },
    storeCategory: {
      storeCategoryNo: null,
      categoryKr: '',
      categoryVn: '',
      regDate: '',
      isActive: true
    },
    totalBizMoney: 0,
    avgStar: 0.0,
    reviewCount: 0,
    replCount: 0,
    favStoreCount: 0,
    favProductCount: 0,
    totalOrderCount: 0
  },
  serviceableAreas: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
